import React from 'react';

export default {
    SimpChn : {
        formTitle: "递交文书清单", 

        // Form fields
        part_a_particulars: "递交文书清单", 

        // Form - Part1
        SolicitorCode: "律师代号",
        NameOfLodgingParty: "交契人士姓名",
        Date: "日期",
        HaveCheque: "使用支票缴交费用",
        field_HaveCheque_list:[
            {id: "HaveCheque", value: "Yes", text: "是"},
            {id: "HaveCheque", value: "No", text: "否", },
        ],
        NoOfCheques: "支票数目",
        TotalAmount: "总额",

        RecordListTitle: "文书清单",
        OrderOfLodgement: "递交文书次序",
        NatureOfInstrument: "文书性质",
        PRN: "受影响处所的物业参考编号/地址(包括座号、层数及单位)/地段编号(包括座号、层数及单位) ",

        Warn_IdenticalInstrument: ()=><>下列文书的描述完全相同。<br/>请检查后再进行下一步。</>,
        Warn_OrderOfLodgement: "文书次序 #{0} 和 #{1}",

        notes1: ()=> [<>
            <div>
                如以邮递方式寄交本表格，请确保为邮件支付足够邮资，以免申请未能成功送达本处。邮资不足的邮件会由香港邮政处理，本处不会代为缴付欠款及附加费。
            </div>
        </>],
        

        acknowledgement_offline_para: ()=>(
            <>
                    <p>你的表格已成功列印。</p>
                    <p>请亲身递交，或以邮寄/传递公司传送表格至本处以递交申请。</p>
            </>
        ), 
    }
}